/**
 * @module  Experience/Softgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { BrowsePlanConfig } from '@core/aem/interfaces/shop/browse-plan.interface';

@Component({
  selector: 'tmo-purchase-device-only',
  templateUrl: './purchase-device-only.component.html',
})
export class PurchaseDeviceOnlyComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Configurable AEM data passed from parent component
   */
  @Input() public aemContent: BrowsePlanConfig;
  @Input() public isNewPlansPageEnabled: boolean;

  /**
   * emitter for triggering call to remove plans from cart
   */
  @Output() public isNoPlanSelected: EventEmitter<boolean>;
  constructor(
    public pdlService: PdlService,
    public activatedRoute: ActivatedRoute
  ) {
    super(pdlService, activatedRoute);
    this.isNoPlanSelected = new EventEmitter<boolean>();
  }

  /**
   * Loads the initial configuration for the component
   * @returns void
   */
  public ngOnInit(): void {}

  public selectPurchaseDeviceOnly(isDevicePurchaseOnly: boolean): void {
    this.isNoPlanSelected.emit(isDevicePurchaseOnly);
  }
}
